import React, {Component} from 'react';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonPage,
  IonPopover,
  IonRadio,
  IonRadioGroup,
  withIonLifeCycle,
} from '@ionic/react';

import {RouteComponentProps} from "react-router";
import {arrangeVideos} from "./placeVideos"
import {openSocket, sendSocket, connectMeeting, closeSocket} from "./socket"
import {
  createLocalInfoDiv,
  createVideoContainer,
  createVideoElement,
  replaceTrackToPeer,
  unmountVideo
} from "./peer";
import {displayVolume} from "./sound";
import {ResourcesInterface, PartnerInterface, DeviceInterface, TalkComponentState} from "./interfaces";
import './Talk.css';
// import Api from "../../services/Api";
import {CONFIG} from "../../constants";
import { arrowBack, ellipsisHorizontal } from 'ionicons/icons';
import { connect } from 'react-redux';
import { openTalk, closeTalk } from '../../redux/actions/talkAction';
import WebSocketClient from "../../services/WebSocketClient"
import Api from '../../services/Api';

interface ComponentProps extends RouteComponentProps<{
  meetingKey: string
  who: string
  name: string
  externalId?: string
}> { 
  user: any
  talkOpen: boolean
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  meetingKey: string
  who: string
  name: string
  externalId?: string
  history: any
  walkId: { walkId: number}
}

class Talk extends Component<ComponentProps, TalkComponentState> {
  private webSocketClient = WebSocketClient.getInstance()
  private api = Api.getInstance()

  resources: ResourcesInterface
  resizeFinished: any
  infoText: string
  userId: string
  userName: string
  userPicture: string
  externalMeeting: boolean

  constructor(props: ComponentProps) {
    super(props);
    let userId: string
    if (this.props.who === 'external') {
      userId = 'external_' + this.props.externalId
      this.externalMeeting = true
    } else {
      userId = window.localStorage[CONFIG.TOKEN_NAME]
      this.externalMeeting = false
    }
    this.infoText = ''
    this.userId = userId
    // this.userName = this.props.match.params.name
    this.userName = this.props.user.person.firstName
    this.userPicture = this.props.user.person.picture
    this.state = {
      videoCompatible: !!navigator.mediaDevices,
      showMenu: false,
      showHelp: false,
      showInfo: false,
      info: '',
      audioDeviceId: 'unset',
      micOn: false,
    }
    this.resources = {
      audioDevices: [],
      partners: [] as Array<PartnerInterface>,
      videoContainerRef: React.createRef(),
      userId: this.userId,
      userName: this.userName,
      who: this.props.who,
      webSocket: undefined,
      meetingKey: this.props.meetingKey,
      stateFunc: this.stateFunc,
      small: false,
      volumeInterval: null,
      webSocketPingInterval: null,
      isMuted: false, 
      userPicture: this.userPicture,
      participantRef: React.createRef()
    }
  }
  

  componentDidMount() {
    this.getInputDevices()
    openSocket(this.resources)

    if (this.resources.webSocket) {
      this.resources.webSocket.onopen = () => {
        const message = {
          type: 'session_init',
          user_id: this.userId,
          user_name: this.userName,
          user_picture: this.userPicture
        }
        sendSocket(message, this.resources.webSocket)
        // console.log('socket onopen: ' + this.resources.webSocket?.readyState)
        this.openLocalVideo(true)

        setTimeout(() => {
          const message = {
            type: 'meeting',
            command: 'participant_count',
            meeting_key: this.props.meetingKey
          }
          sendSocket(message, this.resources.webSocket)
        }, 2000)
      }
    }

    window.addEventListener('resize', this.onResize)
  }

  hangup = () => {
    if (this.props.externalId) {
      window.location.href = '/walk/external_talk_closed/' + this.props.who + '/' +
        this.props.name + '/' + this.props.meetingKey + '/' +
        this.props.externalId
    } else {
      if (this.props.history.length > 2) {
        this.props.history.goBack()
        this.updateParticipant()
      } else {
        window.location.href = '/walk/home'
      }
    }
  }

  componentWillUnmount() {
    // console.log('Talk will unmount')
    window.removeEventListener('resize', this.onResize)
    closeSocket(this.resources)
    unmountVideo(this.resources)
  }

  updateParticipant() {
    // console.log('updating participant')
    this.api.get('walk/talk_participants/' + this.props.walkId.walkId).then(res => {})
  }

  stateFunc = (key: string, value: any) => {
    if (key === 'showInfo') {
      this.setState({showInfo: value})
    } else if (key === 'info') {
      this.setState({info: value})
    } else if (key === 'arrangeVideos') {
      arrangeVideos(this.resources)
    } else {
      // console.log('!!! Unknown key to stateFunc: ' + key)
    }
  }

  // Local video methods

  getInputDevices() {
    navigator.mediaDevices.enumerateDevices().then((deviceInfos: Array<any>) => {
      for (let i = 0; i !== deviceInfos.length; ++i) {
        const device = deviceInfos[i]
        if (device.kind === 'audioinput') {
          this.resources.audioDevices.push({
            id: device.deviceId,
            label: device.label
          })
        }
      }
      this.setState({
        audioDeviceId: this.resources.audioDevices[0].id
      })
    })
  }

  openLocalVideo(firstTime: boolean) {
    const audio = this.state.audioDeviceId === 'unset' ? true : {deviceId: {exact: this.state.audioDeviceId}}
    if (firstTime) {
      this.resources.videoContainer = createVideoContainer(this.resources.videoContainerRef.current)
      this.resources.videoElement = createVideoElement(this.resources.videoContainer)
      createLocalInfoDiv(this.resources, this.resources.videoContainer, this.displayInfo)
    }
    const constraints = {
      audio: audio
    }
    navigator.mediaDevices.getUserMedia(constraints).then((localStream) => {
      this.resources.localStream = localStream
      try {
        if (this.resources.videoElement) {
          this.resources.videoElement.muted = true
          this.resources.videoElement.srcObject = localStream
          // If user changed mic or camera, respect if the turned off camera or mic
          if (!firstTime && !this.state.micOn) {
            this.resources.localStream?.getTracks().forEach((track: MediaStreamTrack) => {
              if (track.kind === 'audio') {
                track.enabled = this.state.micOn
              }
            })
          }
          this.resources.videoElement.onloadedmetadata = () => {
            if (firstTime) {
              arrangeVideos(this.resources)
              this.toggleMic()
              if (this.resources.localStream && this.resources.videoContainer) {
                displayVolume(this.resources.localStream, this.resources.videoContainer, this.resources.volumeInterval)
              }
              connectMeeting(this.resources)
              this.updateParticipant()
            } else {
              replaceTrackToPeer(this.resources)
            }
          }
        } else {
          alert('No microphoneElement')
        }
      } catch (error) {
        alert('Error opening video camera.')
        // console.log(error)
      }
    }).catch(err => {
      alert('Fatal error: Could not connect to your camera')
      // console.log(err)
    })
  }

  onResize = () => {
    clearTimeout(this.resizeFinished);
    this.resizeFinished = setTimeout(() => {
      arrangeVideos(this.resources)
    }, 300);
  }

  changeAudio = (device: DeviceInterface) => {
    if (device.id === this.state.audioDeviceId) {
      // console.log('already selected ' + device.id)
      return
    }
    this.setState({audioDeviceId: device.id}, () => this.openLocalVideo(false))
    // console.log('Changed to ' + device.id)
  }

  displayInfo = (info: string, reset: boolean) => {
    if (reset) {
      this.infoText = ''
    }
    this.infoText += '\n' + info
    this.setState({showInfo: true, info: this.infoText})
  }

  toggleMic = () => {
    const newState = !this.state.micOn
    if (this.resources.localStream) {
      this.resources.localStream.getTracks().forEach((track: MediaStreamTrack) => {
        if (track.kind === 'audio') {
          track.enabled = newState
          this.setState({micOn: newState})
          const message = {
            type: 'meeting',
            command: 'toggleMic',
            user_id_from: this.resources.userId,
            muted: !newState
          }
          // console.log('Mic muted: ' + !newState)
          sendSocket(message, this.resources.webSocket)
        }
      })
    }

  }

  render() {

    if (!this.state.videoCompatible) {
      return (
        <IonPage className="cheap_desktop">
          <IonContent>
            <div className="m-4">Your browser is not compatible with video conferences</div>
          </IonContent>
        </IonPage>
      )
    }

    return (
      <IonModal 
        isOpen={this.props.isOpen}
        onDidDismiss={() => this.props.setIsOpen(false)}>
        <IonHeader>
          <section className="flex justify-between">
            <IonButton 
              class="talkButton" 
              color="teal"
              onClick={() => this.hangup()}>
              <IonIcon icon={arrowBack}/>
              {this.api.tr('leave_room')}
            </IonButton>
            <IonButton 
              fill="clear" 
              class="m-2"
              onClick={() => this.setState({showMenu: !this.state.showMenu})}>
              <IonIcon icon={ellipsisHorizontal} color="dark"/>
            </IonButton>

          </section>
          <section className="fullWidth flex flex-col items-center justify-center">
            <h2>Mötestitel</h2>
            <p className="gray_medium">12.30-13.30</p>
          </section>
        </IonHeader>
        <IonContent id="audio">
          <div ref={this.resources.videoContainerRef} className="videoref"/>

          {
            this.state.showInfo &&
            <div className="video_info_container">
              <div className="video_info">
                <div className="video_close_div" onClick={() => this.setState({showInfo: false})}>X</div>
                <div className="whitespace-pre-line">
                  {this.state.info}
                </div>
              </div>

            </div>
          }

          {/* {
            this.state.showMenu &&
            <div className="video_menu_page">
              <div className="text_right cursor-pointer" onClick={() => this.setState({showMenu: false})}>
                  <img src="assets/icon/close.svg" alt="close" className="icon_medium" />
              </div>

              {
                this.resources.audioDevices.length > 1 &&
                <div className="video_menu_box">
                  <div className="flex items-center">
                      <img src="assets/icon/mic-on.svg" alt="camera" className="video_icon mr-2"/>
                      <b>Mikrofon</b>
                  </div>

                  {
                    this.resources.audioDevices.map((device, index) => {
                      return (
                        <div className="mt-2" key={"audio_" + index} >
                          {
                            device.id === this.state.audioDeviceId ? (
                              <div className="mt-2" key={"audio_" + index}>
                                <i>Används</i>: {device.label}
                              </div>
                            ) : (
                              <div className="mt-2 underline cursor-pointer" key={"video_" + index}
                                   onClick={() => this.changeAudio(device)}>
                                <i>Byt till</i>: {device.label}
                              </div>
                            )
                          }
                        </div>
                      )
                    })
                  }
                </div>
              }
            </div>
          } */}

          {/* <div className="video_footer flex items-center justify-evenly">

            <div className="cursor-pointer video_footer_icon" onClick={() => this.toggleMic()}>
              <img alt="camera" className="video_icon"
                   title={this.state.micOn ? "Stäng av ljud" : "Sätt på ljud"}
                   src={"assets/icon/mic-" + (this.state.micOn ? 'on' : 'off') + ".svg"} />
            </div>

            <div className="cursor-pointer video_footer_icon" onClick={() => this.hangup()}>
              <img title="Lägg på" alt="hangup" className="video_icon"
                   src="assets/icon/phone-off.svg" />
            </div>

            <div className="cursor-pointer video_footer_icon" onClick={() => this.setState({showMenu: !this.state.showMenu})}>
              <img alt="camera" className="video_icon" src="assets/icon/menu-outline.svg" />
            </div>
          </div> */}
        </IonContent>
        <IonFooter class="safe_padding_bottom p-2 flex justify-evenly">
          <article></article>
          <article 
            onClick={() => this.toggleMic()}
            className="flex flex-col p-2 items-center">
            <IonIcon 
              color={this.state.micOn ? 'primary' : 'danger'}
              icon={"assets/icon/mic-" + (this.state.micOn ? 'on' : 'off') + ".svg"} 
              size="large"/>
            <IonLabel 
              color={this.state.micOn ? 'primary' : 'danger'}>{this.state.micOn ? "Stäng av ljud" : "Slå på ljud" }</IonLabel>
          </article>
        </IonFooter>
        <IonPopover
          className='my-custom-class'
          isOpen={this.state.showMenu}
          onDidDismiss={() => {
            this.setState({showMenu: false})}
          }>
          <IonList class="p-2">
            <IonRadioGroup value={this.state.audioDeviceId}>
              <IonListHeader class="p-2 flex items-center">
                <IonIcon icon="assets/icon/mic-on.svg"/>
                Mikrofon</IonListHeader>
              {
                this.resources.audioDevices.map((device, index) => {
                  return (   
                    <IonItem className="mt-2 p-2" key={"audio_" + index}>
                      <IonLabel class="ion-text-wrap">{device.label}</IonLabel>
                      <IonRadio slot="end" value={device.id} 
                        onClick={() => this.changeAudio(device)}/>
                    </IonItem>   
                  )
                })
              }
            </IonRadioGroup>
          </IonList>
        </IonPopover>
      </IonModal>
    );
  }
};

const mapStateToProps = (state: any) => {
  return {
    user: state.logIn.user,
    talkOpen: state.talkOpen.isOpen
  }
}

const mapDispatchToProps = {
  openTalk,
  closeTalk
}

export default connect(mapStateToProps, mapDispatchToProps)(withIonLifeCycle(Talk));
